export const whatIsWifiNodes = [
  {
    id: "136.200.123.175",
    type: "custom",
    position: { x: 545, y: 450 },
    data: { label: "136.200.123.175" },
    className: "what-is-wifi-wifi",
    dragHandle: "noDrag",
  },
  {
    id: "205.243.255.95",
    type: "custom",
    position: { x: 50, y: 450 },
    className: "what-is-wifi-server",
    data: { label: "205.243.255.95" },
    dragHandle: "noDrag",
  },
  {
    id: "242.47.214.213",
    type: "custom",
    position: { x: 300, y: 480 },
    data: { label: "242.47.214.213" },
    className: "what-is-wifi-gateway",
    dragHandle: "noDrag",
  },
  {
    id: "212.68.73.2",
    type: "custom",
    position: { x: 700, y: 480 },
    className: "what-is-wifi-electric-socket",
    data: { label: "" },
    dragHandle: "noDrag",
  },
];
